import React from 'react';
import { map, join, get, isEmpty, isString } from 'lodash';
import searchQuery from 'query-string';
import { withRouter } from 'react-router-dom';
import classnames from 'classnames';

// local dependencies
import { Icon } from 'modules/icon-bank';
import { getLabel } from 'utils/getLabel';
import { button as Button } from 'modules/button';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';
import * as backRoute from 'utils/backRoute';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

const CustomSuccessMessageView = ( props ) => {
    
    if( 'order' === props.type ) {

        const prescription = join( props.message.prescriptions, ', ' );

         // prepare back-route state payload
         const backRouteState = backRoute.encode( {
            pathname: DASHBOARD_SUB_ROUTES.MEMBER_MANAGEMENT,
            payload: {
                memberId: get( props.message, 'memberId', null )
            }
        } );

        return (
            <div className='ui-page-level-success-acknowledgement__message'>
                <span
                    className='ui-page-level-success-acknowledgement__message__action'
                    onClick={ () => {
                        props.history.replace( {
                            pathname: DASHBOARD_SUB_ROUTES.ORDER_DETAIL,
                            search: searchQuery.stringify( {
                                orderId: get( props.message, 'orderId', null ),
                            } ),
                            state: { ...backRouteState, memberId: get( props.message, 'memberId', null ) }
                        } );
                    } }
                >
                    { get( props, 'message.invoiceNumber', '' ) }
                </span>
                <span> - { prescription }</span>
                {/* <Link
                    to={ { pathname: DASHBOARD_SUB_ROUTES.ORDER_DETAIL,
                            search: searchQuery.stringify( {
                                orderId: get( props.message, 'orderId', null ),
                                memberId: get( props.message, 'memberId', null ),
                            } ),
                            state: backRouteState
                        } } >
                        { props.message.orderId } - </Link> */}
            </div>
        );
    }
};

/********************************************* */
const _pageLevelSuccessAcknowledgement = ( props ) => {

    const { title, navActions, type = 'default', message, status = SERVICE_RESPONSE_STATUS.SUCCESS } = props;

    // set icon id and classname based on response status
    const iconId = ( SERVICE_RESPONSE_STATUS.SUCCESS === status ) ? 'hollowSuccessCheck' : 'hollowErrorCross';
    const iconClassname = classnames(
        'ui-page-level-success-acknowledgement__icon', {
            'ui-page-level-success-acknowledgement__icon--error': SERVICE_RESPONSE_STATUS.FAILURE === status
        }
    );

    return (
        <div className='ui-page-level-success-acknowledgement'>

            {/* success icon */}
            <div className={ iconClassname }>
                <Icon id={ iconId } height={ 166 } width={ 166 } />
            </div>

            {/* success title */}
            <div className='ui-page-level-success-acknowledgement__title'>{ isString( title ) ? title : getLabel( title ) }</div>

            {/* custom success message */}
            { ! isEmpty( message ) && (
                <CustomSuccessMessageView  type={ type } message={ message } history={ props.history }/>
            ) }

            { map( navActions, action => {
                return (
                    <Button
                        key={ action.name }
                        className='ui-page-level-success-acknowledgement__action'
                        size='large'
                        { ...action }
                        onClick={ () => props.onActionClick ? props.onActionClick( { action } ): props.history.goBack() }
                    />
                );
            } ) }


        </div>
    );
};

// set display name
_pageLevelSuccessAcknowledgement.displayName = 'pageLevelSuccessAcknowledgement';

// set default props
_pageLevelSuccessAcknowledgement.defaultProps = {};

// prop types
_pageLevelSuccessAcknowledgement.propTypes = {};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { pageLevelSuccessAcknowledgement as PageLevelSuccessAcknowledgement } from 'ui/views/widgets/pageLevelSuccessAcknowledgement';
 *
 * // render
 * <PageLevelSuccessAcknowledgement propName='propValue'/>
 */
export const pageLevelSuccessAcknowledgement = withRouter( _pageLevelSuccessAcknowledgement );
